<template lang="pug">
  div.row
    div.col-10
      vuetable(
        ref="vuetable"
        :api-url="`${server}/api/event/`"
        data-path="results"
        :fields="fields"
        :http-options="httpOptions"
        :css="boostrapCss"
        pagination-path=""
        :append-params="moreParams"
        :per-page="20"
        @vuetable:pagination-data="onPaginationData"
      )
      vuetable-pagination(
        ref="pagination"
        :css="boostrapCss.pagination"
        @vuetable-pagination:change-page="onChangePage"
      )
    div.col-2
      QueryFilter(
        v-on:filter="filter"
        v-on:report="report"
        :showMedRecordNum="true"
        :showMedication="true"
      )

  //- <div>
  //-   <!-- <div class="form-group">
  //-     <label for="">選擇系統</label>
  //-     <select name="" id="" class="form-control" v-model="selectSystem">
  //-       <option value=""> 全選 </option>
  //-       <option :value="sys.id" v-for="sys in system">{{ sys.name }}</option>
  //-     </select>
  //-   </div> -->
  //- </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import FileSaver from 'file-saver';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server, { webSocketServer } from '@/config';
import QueryFilter from './QueryFilter';


Vue.component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  template: `
    <div>{{ rowData.employee_name }}</div>
  `,
});


Vue.component('device', {
  name: 'Device',
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  filters: {
    readablePosistion(val) {
      let pos = `${val.net.open_times}藥櫃 - ${val.net.row_id}層`;
      if (val.pos_row !== 0) {
        pos = `${pos} - ${val.pos_row}列 - ${val.relative_col}行`;
      }
      return pos;
    },
  },
  template: `
    <div v-if="rowData.device !== null || rowData.device !== undefined">{{ rowData.device | readablePosistion }}</div>
    <div v-else>{{ rowData.device_posistion }}</div>
  `,
});


export default {
  name: 'EventSummary',
  data() {
    return {
      moreParams: {},
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      fields: [
        {
          name: 'event_type.event_name_zh',
          sortField: 'event_type',
          title: '動作類別',
        },
        {
          name: 'medication_generic_name',
          sortField: 'medication',
          title: '藥名',
        },
        {
          name: '__component:username',
          sortField: 'employee',
          title: '使用者',
        },
        {
          name: 'review_employee_name',
          title: '覆核者',
        },
        {
          name: 'med_record_no',
          title: '病歷(單)號',
        },
        {
          name: 'device_posistion',
          title: '操作位置',
        },
        {
          name: 'number1',
          title: '變動量',
        },
        {
          name: 'batch_no',
          title: '批號',
        },
        {
          name: 'stock',
          title: '現藥盒量',
        },
        {
          name: 'total_stock',
          title: '總存量',
        },
        {
          name: 'record_time',
          title: '時間',
          sortField: 'record_time',
          callback: this.readableDate,
        },
      ],
      server,
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  components: {
    Vuetable,
    VuetablePagination,
    QueryFilter,
  },
  methods: {
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate(value) {
      //20190426 modified by aaron
      //return moment(value).format('MM/DD kk:mm'); 1~24horu format
      return moment(value).format('MM/DD HH:mm'); //0~23hr format
    },
    filter(params) {
      this.moreParams = params;
      console.log(params);
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    readableDevice(device) {
      if (device !== null) return `第${device.net.open_times}藥櫃 - ${device.net.row_id}層 - ${device.pos_row}列 - ${device.relative_col}行`;
      return undefined;
    },
    connectWebSocket() {
      return new Promise((resolve, rejects) => {
        const wb = new WebSocket(`${webSocketServer}/download-report/${this.$store.state.user.user.id}`);
        wb.onopen = () => {
          this.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = (res) => {
          const data = JSON.parse(res.data);
          if (data.error) {
            this.$store.commit('CLOSE_MESSAGE');
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error,
            });
          }

          if (data.progress !== undefined) {
            this.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            this.instance.get(data.download_path, { responseType: 'blob' })
            .then((res) => {
              FileSaver.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功',
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = () => { rejects(wb); };
      });
    },
    report(params) {
      params.function_name = 'export_event_table';
      this.connectWebSocket().then((ws) => {
        ws.send(JSON.stringify(params));
      })
      .catch((ws) => {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    },
  },
  watch: {
    downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: `
        <h6>產生報告中</h6>
        <div class="progress">
          <div class="progress-bar progress-bar-striped" 
            role="progressbar" 
            style="width: ${val}%; background-color: #117a8b" 
            aria-valuenow="${val}" 
            aria-valuemin="0" 
            aria-valuemax="100">
          </div>
        </div>
        `,
        type: 'clean',
        confirm: false,
      });
    },
  },
};
</script>

<style lang="sass">
.page-active
  background-color: #0056b3
  color: white !important
  &:hover
    background-color: #0056b3

</style>



// WEBPACK FOOTER //
// EventSummary.vue?2aab2ffa